import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarDocumentFilterDropdownTriggerLabel from './VeltCommentsSidebarDocumentFilterDropdownTriggerLabel/VeltCommentsSidebarDocumentFilterDropdownTriggerLabel';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentsSidebarDocumentFilterDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-document-filter-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarDocumentFilterDropdownTrigger.Label = VeltCommentsSidebarDocumentFilterDropdownTriggerLabel;
export default VeltCommentsSidebarDocumentFilterDropdownTrigger;
